import { render, staticRenderFns } from "./ZoomGallery.vue?vue&type=template&id=512494c8&scoped=true&"
import script from "./ZoomGallery.vue?vue&type=script&lang=js&"
export * from "./ZoomGallery.vue?vue&type=script&lang=js&"
import style0 from "./ZoomGallery.vue?vue&type=style&index=0&id=512494c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512494c8",
  null
  
)

export default component.exports